const styles = () => ({
  wrapper: {
    height: '100%'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/layouts/layout-none/layout-none.style.js